import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsLogin implements ICommand
{

	public Token : string = "";
	public BetSource : number = 0;
	public Domain : string = "";
	public LoginLaucherUTCTime : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Token = ba.readString();
		this.BetSource = ba.readUint32();
		this.Domain = ba.readString();
		this.LoginLaucherUTCTime = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.Token);
		ba.writeUint32(this.BetSource);
		ba.writeString(this.Domain);
		ba.writeUint53(this.LoginLaucherUTCTime);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsLogin();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Token(S)='+this.Token+' ';
		str += 'BetSource(D)='+this.BetSource+' ';
		str += 'Domain(S)='+this.Domain+' ';
		str += 'LoginLaucherUTCTime(Q)='+this.LoginLaucherUTCTime+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55001;
	}

	public getCmdName() : string
	{
		return 'PsLogin';
	}

}
